import { render } from "./App.vue?vue&type=template&id=689be696&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=689be696&lang=css"

import exportComponent from "/home/adroneleh/projects/vue-js-matrix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__